import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { openCta, closeCta } from 'LiveBoard/modules/cta'
import PublicEventsDispatcher from 'common/services/PublicEventsDispatcher'
import { CallToAction } from 'LiveBoard/components/shared/CallToAction'
import get from 'lodash/get'

const CallToActionContainer = (props) => {
  const { dispatch, EventTypes } = PublicEventsDispatcher()

  const handleCtaClick = () => {
    if(!props.isOpen) {
      props.openCta()
      props.onOpen && props.onOpen()

      dispatch(EventTypes.ctaClick, {
        ctaType: 'form',
        ctaData: props.config
      })
    }
  }

  const handleCtaClose = () => {
    props.closeCta()
    props.onClose && props.onClose()
  }

  const {
    config, area, themeColorHex, autoOpenOnRender,
    itemId, onCancel, ctaClass, renderCustomButton, tabIndex
  } = props

  return (
    <CallToAction
      config={config}
      area={area}
      themeColorHex={themeColorHex}
      autoOpenOnRender={autoOpenOnRender}
      onCancel={onCancel}
      onClose={handleCtaClose}
      onClick={handleCtaClick}
      itemId={itemId}
      ctaClass={ctaClass}
      renderCustomButton={renderCustomButton}
      modalClass={props.modalClass}
      tabIndex={tabIndex} />
  )
}

CallToActionContainer.defaultProps = {
  ctaClass: '',
  modalClass: ''
}

CallToActionContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  autoOpenOnRender: PropTypes.bool,
  openCta: PropTypes.func.isRequired,
  closeCta: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  renderCustomButton: PropTypes.func,
  modalClass: PropTypes.string
}

function mapStateToProps({ cta }) {
  return { isOpen: get(cta, 'isOpen', false) }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    openCta, closeCta
  }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CallToActionContainer)
